import { useQuery } from '@tanstack/react-query';
import { z } from 'zod';

import { tStoreAuditLog } from '@jane/business-admin/types';
import { fetchWithDecode } from '@jane/business-admin/util';
import { janeApiV2 } from '@jane/shared/data-access';

import { STORES_URL } from './stores';

const fetchStoreAuditLogs = (
  storeId: string | string | number,
  currentPage: number,
  managerId?: string | string | number,
  itemType?: string,
  filterEntityId?: string
): Promise<any> => {
  let storeAuditLogsUrl = `${STORES_URL}/${storeId}/audit_logs?`;
  if (managerId) {
    storeAuditLogsUrl += `manager_id=${managerId}&`;
  }
  if (currentPage) {
    storeAuditLogsUrl += `page=${currentPage}&`;
  }

  if (filterEntityId) {
    storeAuditLogsUrl += `id=${filterEntityId}&`;
  }

  if (itemType) {
    storeAuditLogsUrl += `item_type=${itemType}&`;
  }
  return fetchWithDecode(
    janeApiV2.get(storeAuditLogsUrl),
    z.object({
      data: z.array(tStoreAuditLog),
      meta: z.object({
        next_page: z.number().nullable(),
        prev_page: z.number().nullable(),
      }),
    }),
    storeAuditLogsUrl
  );
};

export const useAuditLogs = ({
  storeId,
  filterEntityId,
  currentPage,
  managerId,
  itemType,
}: {
  currentPage: number;
  filterEntityId?: string;
  itemType?: string;
  managerId?: string | number;
  storeId: string | number;
}) =>
  useQuery({
    queryFn: () =>
      fetchStoreAuditLogs(
        storeId,
        currentPage,
        managerId,
        itemType,
        filterEntityId
      ),
    queryKey: [
      'storeAuditLogs',
      storeId,
      String(managerId),
      itemType,
      filterEntityId,
      currentPage,
    ],
    useErrorBoundary: true,
  });

const fetchAuditLogsFilters = (
  storeId: string | number
): Promise<{ data: string[] }> => {
  const storeAuditLogsUrl = `${STORES_URL}/${storeId}/audit_logs/filters`;
  return fetchWithDecode(
    janeApiV2.get(storeAuditLogsUrl),
    z.object({
      data: z.array(z.string()),
    }),
    storeAuditLogsUrl
  );
};

export const useAuditLogsFilters = ({
  storeId,
}: {
  storeId: string | number;
}) =>
  useQuery({
    queryFn: () => fetchAuditLogsFilters(storeId),
    queryKey: ['storeAuditLogsFilters', storeId],
    useErrorBoundary: true,
  });
